const PROCTORING_ERRORS = {
    PERMISSION_DENIED: 'Permission denied',
    PERMISSION_DENIED_BY_SYSTEM: 'Permission denied by system',
    PERMISSION_DISMISSED: 'Permission dismissed',
    DEVICE_NOT_FOUND: 'Requested device not found',
    SCREEN_SHARE_ENTIRE_SCREEN: 'Please share your entire screen to start the test.',
}

export default PROCTORING_ERRORS
